import classNames from 'classnames';
import React, {FC} from 'react';
import style from './style.module.scss';
import {useGetAbExpressOrder} from 'modules/ab-tests/hooks';

export interface IProps {
    isChecked: boolean;
}

export const FilterSwitch: FC<IProps> = ({isChecked}) => {
    const {isActive: isAbExpressOrder} = useGetAbExpressOrder();

    return (
        <span
            className={classNames(style.main, {
                [style.newBlackStyle]: isAbExpressOrder,
                [style.isChecked]: isChecked,
            })}
        >
            <span className={style.toggle}></span>
        </span>
    );
};
